import { useTranslations } from "next-intl";
import { CookieConsentConfig } from "@/lib/nexus-app";
import { RichTextOrFallback } from "./RichTextOrFallback";
import { BANNER_LINK_CLASS } from "./utils/cookie-consent.utils";

export function CookieConsentNecessaryCard({
  content,
  t,
  onAccept,
}: {
  content: CookieConsentConfig | null | undefined;
  t: ReturnType<typeof useTranslations<"CookieConsent">>;
  onAccept: () => void;
}) {
  return (
    <article className="flex h-full flex-col rounded-xl border border-gray-3 bg-gray-1 p-6">
      <h3 className="text-lg font-semibold text-dark">
        {content?.necessaryTitle || t("necessaryTitle")}
      </h3>
      <p className="mt-3 text-sm leading-6 text-body">
        <RichTextOrFallback
          value={content?.necessaryDescription}
          fallback={t("necessaryDescription")}
          linkClassName={BANNER_LINK_CLASS}
        />
      </p>
      <div className="mt-auto pb-8 pt-14">
        <button
          type="button"
          onClick={onAccept}
          className="mx-auto block w-full max-w-[340px] rounded-lg border border-blue-light-4 bg-blue-light-5 px-4 py-3.5 text-sm font-semibold text-blue-dark transition-colors hover:bg-blue-light-4"
        >
          {content?.acceptNecessaryLabel || t("acceptNecessary")}
        </button>
      </div>
    </article>
  );
}
